export default "__VITE_ASSET__DaOSNLC4__"